import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createCiRelationType, updateCiRelationType, deleteCiRelationType } from "../services/ciRelationTypesApi";

export function useCreateCiRelationType(queryData, handleSuccess, handleError, extendedLog) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createCiRelationType,
    onSuccess: (data) => {
      if (extendedLog) console.log(data);
      queryClient.setQueryData([queryData], (old) => (old ? [...old, data] : data));
      handleSuccess?.(data);
    },
    onError: (error) => {
      if (extendedLog) console.log(error.response?.data);
      handleError?.(error);
    },
  });
}

export function useUpdateCiRelationType(queryData, handleSuccess, handleError, extendedLog) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateCiRelationType,
    onSuccess: (data) => {
      if (extendedLog) console.log(data);
      queryClient.setQueryData([queryData], (old) => old?.map((item) => (item.id === data.id ? data : item)));
      handleSuccess?.(data);
    },
    onError: (error) => {
      if (extendedLog) console.log(error.response?.data);
      handleError?.(error);
    },
  });
}

export function useDeleteCiRelationType(queryData, handleSuccess, handleError) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteCiRelationType,
    onSuccess: (data, publicId) => {
      queryClient.setQueryData([queryData], (old) => old?.filter((item) => item.public_id !== publicId));
      handleSuccess?.();
    },
    onError: (error) => {
      handleError?.(error);
    },
  });
}
